import React from 'react'
import { Outlet } from 'react-router'

export const RootLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Outlet />
    </div>
  )
} 